var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{staticStyle:{"flex-wrap":"wrap"},attrs:{"gutter":10,"type":"flex"}},_vm._l((_vm.imgList),function(item){return _c('el-col',{key:item,staticStyle:{"margin-bottom":"14px"},attrs:{"xs":12,"sm":12,"md":8}},[_c('div',{staticClass:"imgCom"},[_c('img',{attrs:{"src":item,"alt":""}})])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }